import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header.tsx';
import { Footer } from './Footer.tsx';
import DevelopmentBanner from './DevelopmentBanner.tsx';
import PromoAnnouncementBanner from './PromoAnnouncementBanner.tsx';

interface LayoutProps {
  className?: string;
}

export function Layout({ className = 'bg-gray-100' }: LayoutProps) {
  const location = useLocation();
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let messageToShow = null;
    let errorToShow = null;

    if (location.state?.message) {
      messageToShow = location.state.message;
    }
    if (location.state?.error) {
      errorToShow = location.state.error;
    }

    if (messageToShow) setMessage(messageToShow);
    if (errorToShow) setError(errorToShow);

    // Clear the location state after reading it
    // to prevent the message from re-appearing on refresh or back navigation
    if (location.state?.message || location.state?.error) {
      window.history.replaceState({ ...window.history.state, state: null }, '');
    }

    // Auto-clear messages after some time if they were set
    if (messageToShow || errorToShow) {
      const timer = setTimeout(() => {
        setMessage(null);
        setError(null);
      }, 7000); // Display for 7 seconds

      return () => clearTimeout(timer);
    }
  }, [location.state]); // Depend on location.state to re-run when it changes

  return (
    <div className={`min-h-screen flex flex-col ${className}`}>
      <Header />
      {location.pathname === '/markets' && (
        <PromoAnnouncementBanner />
      )}
      <DevelopmentBanner />
      <main className="flex-grow">
        <div className="container mx-auto px-4 pt-4">
          {message && (
            <div 
              className="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-md shadow-sm"
              role="alert"
            >
              {message}
            </div>
          )}
          {error && (
            <div 
              className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-md shadow-sm"
              role="alert"
            >
              {error}
            </div>
          )}
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
} 